import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-owner-info.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-owner-info.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { takeUntil } from "rxjs/operators";
let SearchOwnerInfoComponent = class SearchOwnerInfoComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    _destroy$ = new Subject();
    ownerInfoNameLabel = ApplicationSearchConstants.FORM_CONTROLS.nameLabel;
    ownerInfoSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.surnameLabel;
    ownerInfoOrganisationLabel = ApplicationSearchConstants.FORM_CONTROLS.organisationLabel;
    ownerInfoNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    ownerInfoSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    ownerInfoOrganisationFormControl = ApplicationSearchConstants.FORM_CONTROLS.organisationFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    ownerInfoForm;
    tabChanged;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.ownerInfoForm = val;
            }
        });
        this.tabChanged = false;
        const name = this.ownerInfoForm.get(this.ownerInfoNameFormControl).value;
        const surname = this.ownerInfoForm.get(this.ownerInfoSurnameFormControl).value;
        const organisation = this.ownerInfoForm.get(this.ownerInfoOrganisationFormControl).value;
        if (!this.tabChanged) {
            this.applicationSearchCallback(this.applicationSearchService.searchByOwnerInfo(name, surname, organisation, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
        }
    }
    setUpForm() {
        this.ownerInfoForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            organisationFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
};
SearchOwnerInfoComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-owner-info-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchOwnerInfoComponent);
export { SearchOwnerInfoComponent };
